
import Component, { ComponentMethods } from "@/module/component/component"

import compModel from "@/components/comp-model.vue"
import compFormSmall from "@/components/comp-form-small.vue"

class CompFormView extends ComponentMethods implements ComponentEntity {
    public components = {
        compModel,
        compFormSmall,
    }

    data() {
        return {
            title: "表单",
            formStructure: null,
            formSubmitApi: null,
        }
    }

    methods = {
        display(param: obj) {
            this.param = param
            this.title = param.title
            this.formStructure = param.structure
            this.formSubmitApi = param.submitApi
            this.$refs.form_model.onDisplay()
        },

        onSubmit() {
            this.$refs.form_model.close()

            this.$emit("on-submit", {
                tag: "CompForm",
                value: this.param,
            })
        },

        onClose() {
            this.$refs.form.clear()

            setTimeout(() => {
                this.formStructure = null
            }, 500)
        }
    }
}

export default Component.build(new CompFormView())
